import { Component, h } from 'preact';
import { Properties } from '../../../../common';
import { WithStyles, withStyles } from '../../../../style';
import * as styles from '../AirCalendarModal.scss';
import { DateFormat, DateText, WeekdayFormat, WeekdayText } from '../../../../i18n/Format';
import { WEEKDAYS } from '../../../../common/calendar';

export interface AirCalendarDateHeaderProps extends Properties {
  dateString: string;
  isHighlighted: boolean;
  accessibilityScope: string;
}

type EffectiveProps = AirCalendarDateHeaderProps & WithStyles;

@withStyles(styles)
export default class AirCalendarDateHeader extends Component<AirCalendarDateHeaderProps> {
  render({ tx, dateString, isHighlighted, accessibilityScope }: EffectiveProps): h.JSX.Element {
    const date: Date = new Date(`${dateString}T00:00:00.000Z`);
    return (
      <th
        scope={accessibilityScope}
        class={tx('border ps-xsmall-y nordic-blue-900-text', {
          'grey-100-bg': !isHighlighted,
          'nordic-blue-50-bg': isHighlighted,
        })}
      >
        <div class={tx('flex flex--column regular-type font-body-1')}>
          <div>
            <WeekdayText value={WEEKDAYS[date.getUTCDay()]} format={WeekdayFormat.SHORT} />
          </div>
          <div class={tx('medium-type')}>
            <DateText value={dateString} format={DateFormat.DATE_AND_MONTH} />
          </div>
        </div>
      </th>
    );
  }
}
